export type FeatureFlag = {
  name: string;
  type: "boolean" | "date";
};

export const FEATURE_FLAGS: Record<string, FeatureFlag["type"]> = {
  FEATURE_CLAIMS: "boolean",
  FEATURE_CONDEMN: "boolean",
  FEATURE_RECEIVAL: "boolean",
  PERFORMANCE_REPORT: "boolean",
  FEATURE_MANNING: "boolean",
  MANNING_OPENING_PERIOD: "date",
  FEATURE_STOCKTAKING: "boolean",
  STOCKTAKING_OPENING_PERIOD: "date",
  FEATURE_MANNING_REOPEN: "boolean",
  FEATURE_STOCKTAKING_REOPEN: "boolean",
  FEATURE_STOCKTAKING_PRINTING: "boolean",
  FEATURE_CASH_PURCHASE: "boolean",
};